import * as React from "react";
import { useModal } from "../../../../utils/custom-hooks";
import { DeprecatedTooltip } from "../../../atoms/deprecated-tooltip";
import classNames from "classnames";
import OutsideClickHandler from "@graffer-inc/react-outside-click-handler";
import {
  StatusList,
  StatusValue,
} from "../../../../application/domain/proc-management";
import ProcedureStatusTag from "../../../atoms/proc-management/procedure-status-tag";
import { useStatusFilterState } from "../../common/hooks/useStatusFilterState";

export const StatusFilterDropDown: React.FC<{
  children: React.ReactNode;
  selectedStatuses: StatusValue[];
  defaultStatuses: StatusValue[];
  onSelect: (selected: StatusValue[]) => void;
}> = ({ selectedStatuses, defaultStatuses, onSelect, children }) => {
  const {
    isLocalStorageEnabled,
    setStorageFilterEnabled,
    storageFilterEnabled,
    setStatus,
    status,
  } = useStatusFilterState(
    selectedStatuses.length > 0
      ? {
          storageKey: "ProcManagementStatusFilter",
          preferredStatuses: selectedStatuses,
        }
      : {
          storageKey: "ProcManagementStatusFilter",
          defaultStatuses,
        },
  );

  const statusDropdown = useModal();

  React.useEffect(() => {
    onSelect(status);
  }, [status, onSelect]);

  return (
    <div // buttonタグではIEでpopup表示されない
      className={classNames(
        "dropdown is-right c-hoverable is-size-6 has-text-weight-bold has-text-left",
        {
          "is-active": statusDropdown.isActive,
        },
      )}
      onClick={
        statusDropdown.isActive ? statusDropdown.close : statusDropdown.open
      }
    >
      <div className="dropdown-trigger">
        <span>{children}</span>
        <span className="icon is-small pl-2">
          {storageFilterEnabled ? (
            <i className="fas fa-thumbtack" aria-hidden="true" />
          ) : (
            <i className="fas fa-angle-down" aria-hidden="true" />
          )}
        </span>
      </div>
      <OutsideClickHandler onOutsideClick={statusDropdown.close}>
        <div className="dropdown-menu" role="menu">
          <div className="dropdown-content p-0">
            {StatusList.map((statusMaster) => (
              <React.Fragment key={statusMaster}>
                <button
                  className="button is-fullwidth has-text-left is-white p-5"
                  onClick={(e) => {
                    e.stopPropagation();
                    const newStatus =
                      status.length === 0
                        ? [statusMaster]
                        : status.includes(statusMaster)
                          ? status.filter((s) => s !== statusMaster)
                          : [...status, statusMaster];
                    setStatus(
                      newStatus.length > 0 ? newStatus : [...StatusList],
                    );
                  }}
                >
                  <div className="column is-narrow pl-4 py-2 py-1">
                    <input
                      type="checkbox"
                      checked={status.includes(statusMaster)}
                    />
                  </div>
                  <div className="column px-2 py-1 has-text-weight-bold">
                    <ProcedureStatusTag status={statusMaster} />
                  </div>
                </button>
                <hr className="dropdown-divider m-0" />
              </React.Fragment>
            ))}
            {isLocalStorageEnabled && (
              <button
                className="button is-fullwidth has-text-left is-white p-5"
                onClick={(e) => {
                  e.stopPropagation();
                  setStorageFilterEnabled(!storageFilterEnabled);
                }}
              >
                <div className="field">
                  <input
                    type="checkbox"
                    className="switch is-small is-rounded"
                    checked={storageFilterEnabled}
                  />
                  <label>
                    フィルタ条件を保持する
                    <DeprecatedTooltip text={explanation} />
                  </label>
                </div>
              </button>
            )}
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
};
const explanation = [
  "フィルタ条件をブラウザに保存します。",
  "常に選択したステータスで絞り込まれたデータが一覧表示されます。",
].join("\n");
